export enum RainUnits {
  MilliMeters = 'Millimeters',
  Inches = 'Inches',
}

export const RainUnitsDisplay = new Map<RainUnits, string>([
  [RainUnits.MilliMeters, 'mm'],
  [RainUnits.Inches, 'inches'],
]);

export interface RainfallEnabledDetails {
  isEnabled: boolean;
  units?: RainUnits;
}
